import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import Link from "next/link";
import React from "react";

type Props = {
  data: Simplify<Content.DisabilitySupportSectionSliceDefaultPrimaryDisabilitySupportCardsItem>;
};

export default function DisabilitySupportCard({ data }: Props) {
  return (
    <Card className="shadow-none border-none bg-[#FAFDFF]">
      <CardHeader>
        <CardTitle>
          <div className="flex items-start md:items-center gap-4">
            <Button
              size="icon"
              className="rounded-full bg-[#EBF7FF] shrink-0 size-14"
            >
              <PrismicNextImage field={data.icon} alt="" />
            </Button>

            <p className="text-2xl md:text-3xl font-semibold text-primary">
              {data.title}
            </p>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="md:px-24">
        <PrismicRichText
          field={data.description}
          components={{
            paragraph: ({ children }) => (
              <p className="font-merriweather text-lg text-primary">
                {children}
              </p>
            ),
            hyperlink: ({ children, node }) => (
              <Link
                href={node.data.url || "#"}
                className="text-secondary underline"
              >
                {children}
              </Link>
            ),
          }}
        />
      </CardContent>
    </Card>
  );
}
